import React from 'react';
import ReactDOM from 'react-dom/client';
// Design system: base tokens + component styles, then the rescoped [data-theme] themes.
// `./index.css` is imported last so the portfolio's existing base styles win on legacy pages.
import '@oscarrf2/goo-ds/tokens.css';
import '@oscarrf2/goo-ds/styles.css';
import './styles/ds-themes.css';
// Light / dark skin over the Light theme. After ds-themes.css, whose
// `:root[data-theme="light"]` block it overrides at equal specificity.
import './styles/portfolio-appearance.css';
import './index.css';
// Article reading system (measure, type scale, vertical rhythm). Last, so its
// two-class rules land after both the DS typography classes and Tailwind's
// utility layer.
import './styles/research-article.css';
import './styles/home.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ensure a DS theme is always active before first paint (no flash of unthemed UI).
// The rescoped theme blocks in ./styles/ds-themes.css are keyed off [data-theme].
if (!document.documentElement.dataset.theme) {
  document.documentElement.dataset.theme = 'light';
}
if (!document.documentElement.dataset.appearance) {
  document.documentElement.dataset.appearance = 'light';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
